import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Wave: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m512.69 561.92c-58.61 0-96.33-80.42-136.27-165.55-32.61-69.51-69.56-148.29-109.11-148.29s-87 80.64-118.73 148.29c-3.52 7.5-12.45 10.73-19.95 7.21s-10.73-12.45-7.21-19.95c52.98-112.95 99.34-165.55 145.89-165.55 58.61 0 96.33 80.41 136.27 165.55 32.61 69.51 69.56 148.29 109.11 148.29s87-80.64 118.73-148.29c3.52-7.5 12.45-10.73 19.95-7.21s10.73 12.45 7.21 19.95c-52.98 112.95-99.34 165.55-145.89 165.55z' />
  </IconBase>
));

Wave.displayName = 'Wave';

export default Wave;
